import {IdentityCardTypesResponseBody} from '@dms/api/shared';

export const identityCardTypesResponseMock: IdentityCardTypesResponseBody[] = [
  {
    code: 'ID_IDENTITY_CARD',
    name: 'Identity Card',
  },
  {
    code: 'ID_DRIVER_LICENSE',
    name: 'Driving license',
  },
  {
    code: 'ID_PASSPORT',
    name: 'Passport',
  },
  {
    code: 'ID_GREEN_CARD',
    name: 'Green card',
  },
  {
    code: 'ID_FIREARMS_LICENCE',
    name: 'Firearms licence',
  },
  {
    code: 'ID_OTHER',
    name: 'Other',
  },
];
